const prefix = 'sectionhelper';
export const dataHooks = {
    prefix: `${prefix}-prefix`,
    closeButton: `${prefix}-close-btn`,
    title: `${prefix}-title`,
    content: `${prefix}-content`,
    actionButton: `${prefix}-action-btn`,
};
export const APPEARANCE = {
    Warning: 'warning',
    Standard: 'standard',
    Danger: 'danger',
    Success: 'success',
    Premium: 'premium',
    Preview: 'preview',
    ExperimentalDark: 'experimentalDark',
};
export const SIZE = {
    Small: 'small',
    Medium: 'medium',
};
export const LAYOUT = {
    Vertical: 'vertical',
    Horizontal: 'horizontal',
};
export const BORDER = {
    Standard: 'standard',
    TopBottom: 'topBottom',
};
//# sourceMappingURL=constants.js.map